import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import BottomNavigation from './BottomNavigation';
import OfflineStatus from './OfflineStatus';

const MainLayout = () => {
  const [headerTitle, setHeaderTitle] = useState("");

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-purple-50 to-white">
      <OfflineStatus />
      <Header title={headerTitle} />
      <main className="flex-grow overflow-y-auto pb-20 pt-4">
        <div className="max-w-md mx-auto px-4">
          <Outlet context={{ setHeaderTitle }} />
        </div>
      </main>
      <BottomNavigation />
    </div>
  );
};

export default MainLayout; 